/**
 * SubformulaHeaderCollapseToggle — expand/collapse subformula body
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';

export interface SubformulaHeaderCollapseToggleProps {
  bodyId: string;
  expanded: boolean;
  onToggle: () => void;
}

const SubformulaHeaderCollapseToggle: FC<SubformulaHeaderCollapseToggleProps> = ({
  bodyId,
  expanded,
  onToggle,
}) => (
  <Button
    type="button"
    variant="ghost"
    size="icon"
    className="h-8 w-8 shrink-0"
    aria-expanded={expanded}
    aria-controls={bodyId}
    title={expanded ? 'Collapse subformula' : 'Expand subformula'}
    onClick={onToggle}
  >
    {expanded ? (
      <ChevronDown className="h-4 w-4" aria-hidden />
    ) : (
      <ChevronRight className="h-4 w-4" aria-hidden />
    )}
  </Button>
);

export default SubformulaHeaderCollapseToggle;
